/**
 * Module Settings - GSAP Animations
 * Handles module entrance animations using GSAP
 */

console.log('Module Settings JS loaded');

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Make GSAP available globally
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

document.addEventListener('DOMContentLoaded', function() {

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  // Animate modules on scroll
  const modules = document.querySelectorAll('[data-animate]');

  // Skip animations on iOS — show all immediately
  if (isIOS) {
    modules.forEach(module => {
      const target = module.querySelector('.module-inner') || module.querySelector('.container') || module.firstElementChild || module;
      gsap.set(target, { opacity: 1, x: 0, y: 0, scale: 1 });
    });
    return;
  }

  modules.forEach((module, index) => {
    const animationType = module.dataset.animate;
    
    // Debug: Log module animation details
    console.log(`Module ${index + 1}:`, {
      type: animationType,
      duration: module.dataset.animationDuration,
      delay: module.dataset.animationDelay,
      easing: module.dataset.animationEasing
    });
    
    // Get custom animation parameters
    const duration = parseFloat(module.dataset.animationDuration) || 0.8;
    const delay = parseFloat(module.dataset.animationDelay) || 0;
    const easing = module.dataset.animationEasing || 'power2.out';
    
    // Apply animation to inner content, not the wrapper
    const animationTarget = module.querySelector('.module-inner') || module.querySelector('.container') || module.firstElementChild || module;
    
    let animation = {};
    
    switch(animationType) {
      case 'fade':
        animation = {
          opacity: 0,
          duration: duration,
          delay: delay,
          ease: easing
        };
        break;
        
      case 'slide-up':
        animation = {
          opacity: 0,
          y: 50,
          duration: duration,
          delay: delay,
          ease: easing
        };
        break;
        
      case 'slide-left':
        animation = {
          opacity: 0,
          x: -50,
          duration: duration,
          delay: delay,
          ease: easing
        };
        break;
        
      case 'slide-right':
        animation = {
          opacity: 0,
          x: 50,
          duration: duration,
          delay: delay,
          ease: easing
        };
        break;
        
      case 'scale':
        animation = {
          opacity: 0,
          scale: 0.9,
          duration: duration,
          delay: delay,
          ease: easing
        };
        break;
        
      default:
        animation = {
          opacity: 0,
          y: 30,
          duration: duration,
          delay: delay,
          ease: easing
        };
    }
    
    gsap.from(animationTarget, {
      ...animation,
      scrollTrigger: {
        trigger: module,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleActions: 'play none none none'
      }
    });
  });
  
  // Parallax backgrounds
  const parallaxElements = document.querySelectorAll('[data-parallax]');
  
  parallaxElements.forEach(element => {
    const speed = element.dataset.parallax || 0.5;
    
    gsap.to(element, {
      yPercent: -50 * speed,
      ease: 'none',
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true
      }
    });
  });
});
